import z from 'zod';
import { AllCharLabelSchema, CognitoUserIdSchema, UnixTimestampSchema } from '../common/schemas';
import { DBTimestampSchema } from '../common/sql';
import { AppUserRole } from './enums';

/**
 * DB Schemas
 */

export const DBAppUserRoleValueSchema = z.enum(AppUserRole);

export const DBAppUserSchema = z.object({
  id: CognitoUserIdSchema,
  displayName: AllCharLabelSchema.nullable(),
  createdAt: DBTimestampSchema,
  updatedAt: DBTimestampSchema.nullable(),
});

export const DBAppUserRoleSchema = z.object({
  userId: CognitoUserIdSchema,
  role: DBAppUserRoleValueSchema,
  createdAt: DBTimestampSchema,
});

/**
 * Client Schemas
 */

export const AppUserIdSchema = CognitoUserIdSchema.openapi({
  description: 'The Cognito access-token sub of the user',
});

export const AppUserRoleValueSchema = z.enum(AppUserRole).openapi({
  description: 'A role the user holds, one per Cognito group they are in',
  example: AppUserRole.Teacher,
});

export const AppUserSchema = z.object({
  id: AppUserIdSchema,
  displayName: AllCharLabelSchema.nullable(),
  createdAt: UnixTimestampSchema,
  updatedAt: UnixTimestampSchema.nullable(),
});

export const AppUserRoleSchema = z.object({
  userId: AppUserIdSchema,
  role: AppUserRoleValueSchema,
  createdAt: UnixTimestampSchema,
});

/** A user with every role they hold, in no particular order. */
export const AppUserWithRolesSchema = AppUserSchema.extend({
  roles: z.array(AppUserRoleValueSchema),
});
